import { doGet, doPost, doPut } from 'hooks/requests';

export const useAutomatiqB2bService = () => {
    const addToken = (data) => doPost(`/automatiq-b2b/add-token/`, data);
    const getToken = (data) => doGet(`/automatiq-b2b/get-token/?company_id=${data.companyId}`);
    const updateToken = (data) => doPut(`/automatiq-b2b/update-token/`, data);

    const getAutomatiqB2bPayments = (companyId) => doPost(`/automatiq-b2b/sync-payments/`, { company_id: companyId });

    return {
        addToken,
        getToken,
        updateToken,
        getAutomatiqB2bPayments
    };
};
